<div class="flex flex-col gap-6">
  <div class="flex flex-col lg:flex-row lg:items-start gap-6">
    <!-- DÉTAILS -->
    <div class="card w-full lg:w-7/12">
      <div class="px-gutter py-4 border-b flex flex-wrap items-center justify-between gap-2">
        <div class="flex items-center gap-2">
          <h2 class="title m-0">Détails</h2>
          <team-action-mock-new [show]="settings.showNew"></team-action-mock-new>
        </div>
        <button mat-stroked-button color="primary" type="button" (click)="edit()">
          <mat-icon class="mr-1">edit</mat-icon>
          MODIFIER
        </button>
      </div>
      <div class="px-gutter py-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6">
        <div class="flex items-center py-3">
          <div
            class="w-10 h-10 rounded-full bg-primary-light text-primary mr-3 flex items-center justify-center flex-none"
          >
            <mat-icon>groups</mat-icon>
          </div>
          <div>
            <p class="m-0 body-1">{{ team.name }}</p>
            <p class="m-0 caption text-hint">NOM</p>
          </div>
        </div>
        <div class="flex items-center py-3">
          <div
            class="w-10 h-10 rounded-full bg-primary-light text-primary mr-3 flex items-center justify-center flex-none"
          >
            <mat-icon>badge</mat-icon>
          </div>
          <div>
            <p class="m-0 body-1">{{ team.role }}</p>
            <p class="m-0 caption text-hint">RÔLE</p>
          </div>
        </div>
        <div class="flex items-center py-3">
          <div
            class="w-10 h-10 rounded-full bg-primary-light text-primary mr-3 flex items-center justify-center flex-none"
          >
            <mat-icon>hub</mat-icon>
          </div>
          <div>
            <p class="m-0 body-1">{{ team.support.name }}</p>
            <p class="m-0 caption text-hint">ÉTABLISSEMENT SUPPORT</p>
          </div>
        </div>
        <div class="flex items-center py-3">
          <div
            class="w-10 h-10 rounded-full bg-primary-light text-primary mr-3 flex items-center justify-center flex-none"
          >
            <mat-icon>mail</mat-icon>
          </div>
          <div class="min-w-0">
            <p class="m-0 body-1 truncate">{{ team.email }}</p>
            <p class="m-0 caption text-hint">ADRESSE COMMUNE</p>
          </div>
        </div>
      </div>
    </div>

    <!-- PÉRIMÈTRE -->
    <div class="card flex-auto">
      <div class="px-gutter py-4 border-b">
        <h2 class="title m-0">Périmètre</h2>
        <p class="m-0 caption text-secondary">Établissements clients de {{ team.support.name }}</p>
      </div>
      <div class="px-gutter py-2">
        <div *ngFor="let client of team.support.clients" class="flex items-center gap-3 py-3">
          <mat-icon class="text-secondary">apartment</mat-icon>
          <span class="body-1">{{ client.name }}</span>
          <span class="caption text-hint">{{ client.city }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- MEMBRES -->
  <div class="card">
    <div class="px-gutter py-4 border-b flex flex-wrap items-center justify-between gap-4">
      <h2 class="title m-0">Membres ({{ members.length }})</h2>
      <button mat-stroked-button color="primary" type="button" (click)="openAdd()">
        <mat-icon class="mr-1">person_add</mat-icon>
        AJOUTER UN MEMBRE
      </button>
    </div>
    <div class="px-gutter py-2">
      <div *ngFor="let row of members" class="flex items-center gap-3 py-3">
        <div
          class="w-10 h-10 rounded-full bg-gray-light text-secondary flex items-center justify-center flex-none body-2"
        >
          {{ row.initials }}
        </div>
        <div class="flex-auto min-w-0">
          <p class="m-0 body-1 flex items-center gap-2">
            {{ row.member.fullName }}
            <mat-icon *ngIf="row.issue" class="text-warn" [matTooltip]="row.issue">error</mat-icon>
          </p>
          <p class="m-0 caption text-secondary truncate">Affectations : {{ row.establishments }}</p>
        </div>
        <button mat-button color="warn" type="button" (click)="openRemoval(row.member)">RETIRER</button>
      </div>
    </div>
  </div>

  <!-- DÉSIGNATIONS -->
  <div class="card overflow-hidden">
    <div class="px-gutter py-4 border-b">
      <h2 class="title m-0">Où cette équipe est désignée</h2>
    </div>
    <table mat-table [dataSource]="team.usages" class="w-full shadow-none">
      <ng-container matColumnDef="establishment">
        <th mat-header-cell *matHeaderCellDef>Établissement client</th>
        <td mat-cell *matCellDef="let usage">{{ usage.establishment.name }}</td>
      </ng-container>
      <ng-container matColumnDef="scope">
        <th mat-header-cell *matHeaderCellDef>Famille</th>
        <td mat-cell *matCellDef="let usage" class="text-secondary">{{ usage.scope }}</td>
      </ng-container>
      <ng-container matColumnDef="designation">
        <th mat-header-cell *matHeaderCellDef>Désignation</th>
        <td mat-cell *matCellDef="let usage">{{ usage.designation }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
